import { Section, Question } from "./interfaces";

const objectFromFlatQuestions = (flatQuestionsArray: any[]): Section[] => {
  const form = flatQuestionsArray.sort((a: any, b: any) =>
    a.questionNumber > b.questionNumber
      ? 1
      : b.questionNumber > a.questionNumber
      ? -1
      : 0
  );

  const sections: Section[] = [];

  // Create initial Sections Array
  form.forEach((el: Question, idx: number) => {
    if (idx === 0) {
      let s: Section = {
        title: el.category,
        fields: []
      };
      sections.push(s);
    } else if (el.category !== form[idx - 1].category) {
      let s: Section = {
        title: el.category,
        fields: []
      };
      sections.push(s);
    }
  });

  sections.forEach((s: Section) => {
    form.forEach((el: Question) => {
      if (el.category === s.title) {
        s.fields.push(el);
      }
    });
  });

  return sections;
};

const objectFromFlatAnswers = (flatAnswers: any[]) => {
  const form = flatAnswers.sort((a: any, b: any) =>
    a.questionNumber > b.questionNumber
      ? 1
      : b.questionNumber > a.questionNumber
      ? -1
      : 0
  );
  interface UserAnswer {
    questionDescription: string;
    userAnswer: string;
    questionNumber: number;
    questionCategory: string;
  }
  interface UserAnswerSection {
    title: string;
    userAnswers: UserAnswer[];
  }

  const sections: UserAnswerSection[] = [];

  form.forEach((el: UserAnswer, idx: number) => {
    if (idx === 0) {
      let s: UserAnswerSection = {
        title: el.questionCategory,
        userAnswers: []
      };
      sections.push(s);
    } else if (el.questionCategory !== form[idx - 1].questionCategory) {
      let s: UserAnswerSection = {
        title: el.questionCategory,
        userAnswers: []
      };
      sections.push(s);
    }
  });

  sections.forEach((s: UserAnswerSection) => {
    form.forEach((el: UserAnswer) => {
      if (el.questionCategory === s.title) {
        s.userAnswers.push(el);
      }
    });
  });

  return sections;
};

export { objectFromFlatQuestions, objectFromFlatAnswers };
